/* Mapping lineGroup icon from iconId */
export const lineGroupIconMapper = iconId => {
    const lineGroupIcons = {
        bank: 'account-balance',
        calendar: 'calendar',
        cash: 'bills',
        coin_drop: 'coin-drop',
        document: 'note',
        info: 'info',
        instrument: 'cash-search',
        letter: 'letter',
        loan: 'loan',
        localization: 'location',
        person_2: 'person',
        person: 'person',
        shoppingcart: 'TODO',
        tag: 'tag',
        transfer: 'transfer',
        undefined: 'no-category',
        wallet: 'wallet-grey',
        settings: 'settings'
    }

    return lineGroupIcons[iconId]
}
